import styled from 'styled-components'
import { THEME } from '../../constant'

export const Step3AHoldWrapper = styled.div`
  padding-bottom: 24px;
  a {
    color: ${THEME.PRIMARY_COLOR};
  }
`
